// extracted by mini-css-extract-plugin
export var topScroll = "ScrollToTopButton-module--topScroll--IRqc7";
export var arrow = "ScrollToTopButton-module--arrow--dBe9O";
export var path = "ScrollToTopButton-module--path--zFnpg";
export var circle = "ScrollToTopButton-module--circle--WHJeA";
export var line = "ScrollToTopButton-module--line--ngDKq";